import { render, staticRenderFns } from "./ManageWallet.vue?vue&type=template&id=1e3f3230&scoped=true&"
import script from "./ManageWallet.vue?vue&type=script&lang=js&"
export * from "./ManageWallet.vue?vue&type=script&lang=js&"
import style0 from "./ManageWallet.vue?vue&type=style&index=0&id=1e3f3230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3f3230",
  null
  
)

export default component.exports